<script>
export default {
	props: {
		select: {
			type: String,
			default: 'projects',
			required: true,
		},
		selectOptions: {
			type: Array,
			default: () => [
				'Web Application',
				'Embeded Systems',
				'UI/UX Design',
				'Games',
				'Mobile Apps',
				'Others',
			],
		},
	},
};
</script>

<template>
	<select
		@change="$emit('filter', $event.target.value)"
		:name="select"
		:id="select"
		class="font-general-medium pl-3 pr-1 sm:px-4 py-2 rounded-lg text-sm sm:text-md border border-white bg-transparent focus:border-red-300 focus:ring-2 focus:ring-red-100 text-gray-500
			"
	>
		<option value class="text-sm sm:text-md">All Projects</option>
		<option
			v-for="option in selectOptions"
			:key="option"
			:value="option"
			class="sm:text-md"
		>
			{{ option }}
		</option>
	</select>
</template>

<style scoped>
</style>
